export default __webpack_public_path__ + "pgnv-assets/5940bee407703e2a6f8167a24176ee5c.svg";